import { createApi } from '@reduxjs/toolkit/query/react';
import { getBaseQuery } from '@edikk-edikk/redux/toolkit';
import { Container } from 'inversify';
import { API_CITIES_IN_MODAL_NAME, LOAD_LIST_URL } from '#baseCitiesInModal/constants';
import { LoadResponseType } from '#baseCitiesInModal/api';

const getApiCitiesInModal = (diContainer: Container) => createApi({
  reducerPath: API_CITIES_IN_MODAL_NAME,
  baseQuery: getBaseQuery(diContainer),
  endpoints: (builder) => ({
    load: builder.query<LoadResponseType, void>({
      query: () => ({
        url: LOAD_LIST_URL,
      }),
    }),
  }),
});

export { getApiCitiesInModal };
